<section class="main-page l-wrapper">
  <div class="page__nav" *ngIf="!breakPoint.isMobile">
    <ng-container *ngIf="(categories$ | async) as menuGroups;">
      <ng-container *ngIf="menuGroups.length;">
        <app-menu-nav [menuGroups]="menuGroups"></app-menu-nav>
      </ng-container>
    </ng-container>
  </div>

  <div class="page__section _flat _aside">
    <div class="menu-head">
      <ng-template #bannerView></ng-template>
    </div>

    <ng-container *ngIf="(loadingMenuStatus$ | async) === false; else loader">
      <ng-container *ngIf="(categories$ | async) as menuGroups;">
        <ng-container *ngIf="menuGroups.length || (activeFilterCount$ | async); else emptyMessage">
          <div class="page__search" *ngIf="{data: searchString$ | async}">
            <label class="page-search">
              <span class="page-search__icon">
                <i class="icomoon icomoon--search"></i>
              </span>
              <input
                [formControl]="searchControl"
                type="text"
                class="page-search__field"
                placeholder="Search"
                i18n-placeholder="@@Search"
                (input)="onSearch()">
            </label>
            <span class="page-search__filter-icon" (click)="toggleShowFilterBar()">
              <i class="icomoon icomoon--filter"></i>
              <div class="page-search__badge-container" *ngIf="activeFilterCount$ | async as activeFilterCount">
                <span class="page-search__filter-badge">{{activeFilterCount}}</span>
              </div>
            </span>
            <span class="page-search__filter-icon" *ngIf="activeFilterCount$ | async" (click)="clearFilter()">
              <i class="icomoon icomoon--trashcan"></i>
            </span>
          </div>
          <div class="page__filter-bar" *ngIf="showFilterBar$ | async">
            <app-filter-bar></app-filter-bar>
          </div>
          <div class="page__nav l-wrapper" [style.top.px]="(showFilterBar$ | async) ? 180 : 72" *ngIf="breakPoint.isMobile">
            <app-menu-nav [menuGroups]="menuGroups"></app-menu-nav>
          </div>
          <router-outlet></router-outlet>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #emptyMessage>
      <div class="message">
        <span class="h4" i18n="@@EmptyCatalogMessage">Sorry, menu is under development. Come back later, many delicious dishes will be prepared here soon!</span>
      </div>
    </ng-template>
  </div>
</section>

<ng-template #loader>
  <div class="spinner-wrap">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</ng-template>
